<template>
  <div>
    <Head title="Información de Versión" />

    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Información de Versión</h1>
      <Link 
        href="/" 
        class="btn-blue p-2 rounded hover:opacity-90 transition-opacity"
      >
        <i class="fa fa-arrow-left mr-2"></i>
        Volver al Dashboard
      </Link>
    </div>

    <div class="bg-white rounded-lg shadow p-6 mb-6">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">
          Versión actual: 
          <span class="badge bg-blue-100 text-blue-800 p-2 rounded-lg">
            v{{ version.major }}.{{ version.minor }}.{{ version.patch }}
          </span>
        </h2>
        <div class="text-gray-600">
          Fecha de lanzamiento: {{ formatDate(version.release_date) }}
        </div>
      </div>

      <div v-if="version.codename" class="mb-4 text-lg text-gray-700">
        Nombre clave: <span class="font-semibold">{{ version.codename }}</span>
      </div>

      <div class="mt-6">
        <h3 class="text-xl font-semibold mb-3">Cambios en esta versión:</h3>
        <ul class="list-disc pl-6 space-y-2">
          <li v-for="(change, index) in version.changelog" :key="index" class="text-gray-700">
            {{ change }}
          </li>
        </ul>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6">
      <h2 class="text-2xl font-bold mb-4">Historial de versiones</h2>
      
      <!-- This would be populated from a versions history endpoint if you implement one -->
      <div class="text-gray-600 italic">
        El historial completo de versiones estará disponible próximamente.
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  name: 'VersionInfo',
  
  components: {
    Head,
    Link
  },
  
  layout: Layout,
  
  props: {
    version: Object
  },
  
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('es-ES', options);
    }
  }
}
</script>

<style scoped>
.badge {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 600;
}
</style>